import { RoleHost } from '../RoleHost';

export function DLWrapper() {
  return <RoleHost role="dl" />;
}
